// Module
var code = "<script>let $ctrl</script> <i class=\"{{ $ctrl.prefix }} fa-{{ $ctrl.icon }} {{ $ctrl.size ? 'fa-' + $ctrl.size : '' }} {{ $ctrl.spin ? 'fa-spin' : '' }} {{ $ctrl.fixedSize ? 'fa-fw' : '' }} {{ $ctrl.color }}\"></i> ";
// Exports
module.exports = code;